import { render, staticRenderFns } from "./video-swiper.vue?vue&type=template&id=6e170204&comments=true&"
import script from "./video-swiper.vue?vue&type=script&lang=js&"
export * from "./video-swiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports